import * as React from "react";
class SmsPreview extends React.Component {
  BEM() {
    const classArray = ["sms-preview"];
    if (this.props.alignContent) {
      classArray.push("sms-preview--" + this.props.alignContent);
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: this.BEM() }, /* @__PURE__ */ React.createElement("div", { className: "sms-preview__container" }, /* @__PURE__ */ React.createElement("div", { className: "sms-preview__container-inner" }, /* @__PURE__ */ React.createElement("div", { className: "sms-preview__text" }, this.props.children))));
  }
}
export {
  SmsPreview
};
